export default __webpack_public_path__ + "static/media/AAVE-ETH.097fb413.png";